import 'css-chunk:src/app/containers/Home/ApplicationsView/EditAppDrawer.scss';export default {
  "EditAppDrawer": "_EditAppDrawer_auhxp_1",
  "form": "_form_auhxp_1",
  "submitButton": "_submitButton_auhxp_1"
};